/**
 * 1-OPH Product Details
 * Product Gallery
 *
 * Native swipe + arrows + dots + thumbnails
 */

document.addEventListener('DOMContentLoaded', function () {

  const gtrack = document.getElementById('gtrack');

  if (!gtrack) {
    return;
  }

  const gslides = Array.from(
    gtrack.children
  );

  if (!gslides.length) {
    return;
  }


  /* =====================================================
     GO TO SLIDE
  ===================================================== */

  function gotoSlide(index) {

    index = Math.max(
      0,
      Math.min(gslides.length - 1, index)
    );

    gtrack.scrollTo({
      left: gslides[index].offsetLeft - gtrack.offsetLeft,
      behavior: 'smooth'
    });

  }


  /* =====================================================
     CURRENT SLIDE
  ===================================================== */

  function currentSlide() {

    return Math.round(
      gtrack.scrollLeft / gtrack.clientWidth
    );

  }


  /* =====================================================
     PREVIOUS / NEXT
  ===================================================== */

  const previousButton =
    document.getElementById('gprev');

  const nextButton =
    document.getElementById('gnext');


  if (previousButton) {

    previousButton.addEventListener(
      'click',
      function () {

        gotoSlide(
          currentSlide() - 1
        );

      }
    );

  }


  if (nextButton) {

    nextButton.addEventListener(
      'click',
      function () {

        gotoSlide(
          currentSlide() + 1
        );

      }
    );

  }


  /* =====================================================
     DOTS + THUMBNAILS
  ===================================================== */

  document
    .querySelectorAll(
      '.oph-pd .gdot, .oph-pd .gthumb'
    )
    .forEach(function (element) {

      element.addEventListener(
        'click',
        function () {

          gotoSlide(
            Number(this.dataset.g)
          );

        }
      );

    });


  /* =====================================================
     SYNC ACTIVE DOT + THUMBNAIL
  ===================================================== */

  gtrack.addEventListener(
    'scroll',
    function () {

      const index = currentSlide();


      document
        .querySelectorAll('.oph-pd .gdot')
        .forEach(function (dot, i) {

          dot.classList.toggle(
            'on',
            i === index
          );

        });


      document
        .querySelectorAll('.oph-pd .gthumb')
        .forEach(function (thumb, i) {

          thumb.classList.toggle(
            'on',
            i === index
          );

        });

    },
    {
      passive: true
    }
  );

});


/* =========================================================
   OPH PRODUCT DETAILS
   SECTION 3: PROJECT STRIP
   ========================================================= */

(function () {

  const track = document.querySelector('[data-project-track]');

  if (!track) {
    return;
  }

  const buttons = document.querySelectorAll('[data-project-nav]');

  buttons.forEach(function (button) {

    button.addEventListener('click', function () {

      const direction = Number(
        button.dataset.projectNav
      );

      const amount = track.clientWidth * 0.85;

      track.scrollBy({
        left: amount * direction,
        behavior: 'smooth'
      });

    });

  });

})();